import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3d8e2e6a&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=3d8e2e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e2e6a",
  null
  
)

export default component.exports